import { Link } from "react-router-dom";

const ISSUES = [
  { id: "4", title: "Consciousness & the Cosmos", date: "Spring 2026", cover: "✨", highlight: true },
  { id: "3", title: "The Inner Healer", date: "Winter 2025", cover: "🔮" },
  { id: "2", title: "Dreams as Medicine", date: "Fall 2025", cover: "🌙" },
  { id: "1", title: "Walking the Aekam Path", date: "Summer 2025", cover: "🏔️" },
];

export function MagazinePage() {
  const [latest, ...past] = ISSUES;

  return (
    <>
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Quarterly Publication</p>
          <h1 className="display-2">The Aekam Magazine</h1>
          <p className="hero__body" style={{ maxWidth: "540px", margin: "0 auto" }}>
            A quarterly journal exploring consciousness, healing, and the wisdom traditions that guide us home.
          </p>
        </div>
      </section>

      {/* Latest Issue */}
      <section className="section">
        <div className="container">
          <p className="eyebrow">Latest Issue</p>
          <div className="magazine-featured">
            <div className="magazine-cover magazine-cover--large">{latest.cover}</div>
            <div className="magazine-featured__body">
              <div className="badge badge--brand" style={{ marginBottom: "0.75rem" }}>New Issue</div>
              <h2 className="magazine-featured__title">{latest.title}</h2>
              <p className="text-muted">{latest.date}</p>
              <p style={{ marginTop: "0.75rem", lineHeight: "1.7" }}>
                In this issue: navigating the relationship between science and mysticism, a conversation
                with Master on out-of-body experiences, and a guide to star-mapping in meditation.
              </p>
              <a href="#" className="btn btn--brand" style={{ marginTop: "1.25rem", display: "inline-block" }}>
                Read Online →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Past Issues */}
      <section className="section section--tight" style={{ background: "var(--c-surface-alt)" }}>
        <div className="container">
          <p className="eyebrow">Past Issues</p>
          <div className="magazine-grid">
            {past.map((issue) => (
              <div key={issue.id} className="magazine-card">
                <div className="magazine-cover">{issue.cover}</div>
                <h3 className="magazine-card__title">{issue.title}</h3>
                <p className="magazine-card__date">{issue.date}</p>
                <a href="#" className="btn btn--outline btn--sm" style={{ marginTop: "0.75rem" }}>Read Online</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section--cta">
        <div className="container" style={{ textAlign: "center" }}>
          <h2>Never miss an issue</h2>
          <p className="text-muted">Subscribe to receive the magazine in print and digital formats.</p>
          <Link to="/donate" className="btn btn--brand btn--lg">Subscribe &amp; Support</Link>
        </div>
      </section>
    </>
  );
}
